import React from 'react';
import Button from 'monday-ui-react-core/dist/Button';
import { openLinkInTab } from '../../utils/monday';

const NeedHelp = () => {
  const openHelpForm = async () => {
    await openLinkInTab({
      url: 'https://wkf.ms/3zrMFIU',
    });
  };

  return (
    <div className="absolute -right-[42px] top-[50%] -translate-y-2/4 -rotate-90 z-50">
      <Button
        kind={Button.kinds.PRIMARY}
        size={Button.sizes.LARGE}
        onClick={openHelpForm}
      >
        Need Help?
      </Button>
    </div>
  );
};

export default NeedHelp;
